'use client';
import { BaseAds } from '@/components/Ads/BaseAds';
import { RESPONSIVE_MARGIN } from '@/functions/createTheme';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

type Props = {
  ads: AdDto[];
};

export const CenterAds: React.FC<Props> = ({ ads }) => {
  const theme = useTheme();

  return (
    <>
      {ads.length > 0 && (
        <Box sx={{ my: RESPONSIVE_MARGIN }}>
          <BaseAds ads={ads} />
          <Box sx={{ mt: 0.5, mr: 0.5, textAlign: 'end' }}>
            <Typography variant="body2" color={theme.palette.grey[700]}>
              PR
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};
